import { tagEmits as B, tagProps as M } from "./index679.js";
import { defineComponent as $, computed as w, openBlock as r, createElementBlock as m, normalizeStyle as y, normalizeClass as n, createElementVNode as u, unref as t, renderSlot as g, withModifiers as h, createVNode as i, withCtx as d, createCommentVNode as v, createBlock as x, Transition as F } from "vue";
import { ElIcon as z } from "./index538.js";
import { Close as E } from "./index537.js";
import { useFormSize as I } from "./index586.js";
import { useLocale as K } from "./index597.js";
import { useNamespace as L } from "./index559.js";
const P = ["aria-label"], j = ["aria-label"];
var Q = /* @__PURE__ */ $({
  name: "ElTag",
  __name: "tag",
  props: M,
  emits: B,
  setup(l, { emit: N }) {
    const T = l, p = N, V = I(), { t: f } = K(), e = L("tag"), b = w(() => {
      const { type: o, hit: a, effect: s, closable: c, round: S } = T;
      return [
        e.b(),
        e.is("closable", c),
        e.m(o || "primary"),
        e.m(V.value),
        e.m(s),
        e.is("hit", a),
        e.is("round", S)
      ];
    }), k = (o) => {
      p("close", o);
    }, C = (o) => {
      p("click", o);
    }, _ = (o) => {
      var a, s, c;
      (c = (s = (a = o?.component) == null ? void 0 : a.subTree) == null ? void 0 : s.component) != null && c.bum && (o.component.subTree.component.bum = null);
    };
    return (o, a) => l.disableTransitions ? (r(), m(
      "span",
      {
        key: 0,
        class: n(b.value),
        style: y({ backgroundColor: l.color }),
        onClick: C
      },
      [
        u(
          "span",
          {
            class: n(t(e).e("content"))
          },
          [
            g(o.$slots, "default")
          ],
          2
          /* CLASS */
        ),
        l.closable ? (r(), m("button", {
          key: 0,
          "aria-label": t(f)("el.tag.close"),
          class: n(t(e).e("close")),
          type: "button",
          onClick: h(k, ["stop"])
        }, [
          i(t(z), null, {
            default: d(() => [
              i(t(E))
            ]),
            _: 1
            /* STABLE */
          })
        ], 10, P)) : v("v-if", !0)
      ],
      6
      /* CLASS, STYLE */
    )) : (r(), x(F, {
      key: 1,
      name: `${t(e).namespace.value}-zoom-in-center`,
      appear: "",
      onVnodeMounted: _
    }, {
      default: d(() => [
        u(
          "span",
          {
            class: n(b.value),
            style: y({ backgroundColor: l.color }),
            onClick: C
          },
          [
            u(
              "span",
              {
                class: n(t(e).e("content"))
              },
              [
                g(o.$slots, "default")
              ],
              2
              /* CLASS */
            ),
            l.closable ? (r(), m("button", {
              key: 0,
              "aria-label": t(f)("el.tag.close"),
              class: n(t(e).e("close")),
              type: "button",
              onClick: h(k, ["stop"])
            }, [
              i(t(z), null, {
                default: d(() => [
                  i(t(E))
                ]),
                _: 1
                /* STABLE */
              })
            ], 10, j)) : v("v-if", !0)
          ],
          6
          /* CLASS, STYLE */
        )
      ]),
      _: 3
      /* FORWARDED */
    }, 8, ["name"]));
  }
});
export {
  Q as default
};
